<h3 class="mb-6">{{ 'ONBOARDING.INSCRIPTION-PAYMENTS.TITLE' | transloco }}</h3>
<div class="flex flex-col mb-4">
  <div class="flex flex-col justify-between gap-4">
    <div class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-2">
        <ion-icon class="text-3xl min-w-8" name="checkmark-circle" color="success"></ion-icon>
        <div class="text-destacadoM font-bree">
          {{ selectedRate?.name }}
        </div>
      </div>
      <div class="text-destacadoM font-bree text-end">
        {{ selectedRate?.price | smartCurrency }}
      </div>
    </div>
    <hr class="m-0" />
    @for (item of selectedExtraServices; track $index) {
      <div class="flex items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          <ion-icon class="text-3xl min-w-8" name="checkmark-circle" color="success"></ion-icon>
          <div class="flex flex-col text-destacadoM font-bree">
            {{ item?.name }}
            <span class="text-sm font-normal font-poppins">
              {{ item?.byPerson ? ' (' + item?.quantity + ' pax)' : '' }}
              {{ !item?.mandatory ? ' (' + item?.quantity + ' u.)' : '' }}
            </span>
          </div>
        </div>
        <div class="text-destacadoM font-bree text-end">
          {{
            item?.byPerson
              ? ((item?.price || 0) * (item?.quantity || 0) | smartCurrency)
              : (item?.price | smartCurrency)
          }}
        </div>
      </div>
      <hr class="m-0" />
    }
    @for (item of selectedExtraServicesOffline; track $index) {
      <div class="flex items-center justify-between gap-2">
        <div class="flex items-center gap-2">
          <ion-icon class="text-3xl min-w-8" name="checkmark-circle" color="success"></ion-icon>
          <div class="flex flex-col text-destacadoM font-bree">
            {{ item?.name }}
            <span class="text-sm font-normal font-poppins">
              {{ 'ONBOARDING.REGISTER.PAYMENT.MANDATORY_PAYMENT_OFFLINE_DESC' | transloco }}
            </span>
          </div>
        </div>
        <div class="text-destacadoM font-bree text-end">
          {{
            item?.byPerson
              ? ((item?.price || 0) * (item?.quantity || 0) | smartCurrency)
              : (item?.price | smartCurrency)
          }}
        </div>
      </div>
      <hr class="m-0" />
    }
  </div>
  @if (showAddService) {
    <div class="mt-4 border p-2 rounded flex gap-5 flex-col">
      <div>
        <div class="flex items-center justify-between gap-2">
          <div class="text-destacadoM font-bree">{{ 'ONBOARDING.INSCRIPTION-PAYMENTS.TOTAL-ONLINE' | transloco }}</div>
          <div class="text-destacadoM font-bree">{{ totalOnlineAmount | smartCurrency }}</div>
        </div>
        <div class="mt-2">
          <div class="font-bree">{{ 'ONBOARDING.INSCRIPTION-PAYMENTS.STATUS' | transloco }}</div>
          <div>
            {{ 'ONBOARDING.INSCRIPTION-PAYMENTS.PENDING' | transloco: { amount: pendingOnlineAmount | smartCurrency } }}
          </div>
        </div>
      </div>
      @if (pendingOnlineAmount > 0) {
        <gt-button expand="full" [routerLink]="['/payment', 'method', inscription.id]">
          {{ 'HOME.COMPLETE_PAYMENT_BUTTON' | transloco }}
        </gt-button>
      }
      <div>
        <div class="flex items-center justify-between gap-2">
          <div class="text-destacadoM font-bree">{{ 'ONBOARDING.INSCRIPTION-PAYMENTS.TOTAL-OFFLINE' | transloco }}</div>
          <div class="text-destacadoM font-bree">{{ totalOfflineAmount | smartCurrency }}</div>
        </div>
        <div class="mt-2">
          <div class="font-bree">{{ 'ONBOARDING.INSCRIPTION-PAYMENTS.STATUS' | transloco }}</div>
          <div>
            {{
              'ONBOARDING.INSCRIPTION-PAYMENTS.PENDING'
                | transloco
                  : {
                      amount: inscription.offlinePaid ? 0 : (pendingOfflineAmount | smartCurrency),
                    }
            }}
          </div>
        </div>
      </div>
    </div>
  }
</div>

@if (showAddService && edition.enableInscriptions && !allServicesAreRequested) {
  <h3 class="mt-4">{{ 'ONBOARDING.INSCRIPTION-PAYMENTS.TITLE-ADD' | transloco }}</h3>
  <gt-button [routerLink]="['add-payment']">
    {{ 'ONBOARDING.INSCRIPTION-PAYMENTS.BUTTON-ADD' | transloco }}
  </gt-button>
}
